import TEMPLATE_URL from "emun.commissioning/payperiods/payperiod-prompt.htm";
import controller from "emun.commissioning/payperiods/payperiod-prompt.controller";
import modals from "webmodals/modals";

const NOOP = () => {};

export default ({
  size = "xs",
  backdrop = "static",
  templateUrl = TEMPLATE_URL,
  request: {
    id,
    status,
    startOn,
    endOn,
//    tags = [],
  } = {},
  action = id ? "Update" : "Create",
  title = `${action} Pay Period`,
} = {}) =>
  modals.open({
    size,
    backdrop,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => ({
        title,
        request: {
          id,
          status,
          startOn,
          endOn,
//          tags: [...tags],
        }
      })
    }
  }).result;
